let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f3U59")).then(() => parcelRequire('fIQox'));